import { render, staticRenderFns } from "./UndoReplacementsNew.vue?vue&type=template&id=6ea5eafe&"
import script from "./UndoReplacementsNew.vue?vue&type=script&lang=js&"
export * from "./UndoReplacementsNew.vue?vue&type=script&lang=js&"
import style0 from "./UndoReplacementsNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports